import { render, staticRenderFns } from "./ProgressReportDocuments.vue?vue&type=template&id=124e1c7f&"
import script from "./ProgressReportDocuments.vue?vue&type=script&lang=js&"
export * from "./ProgressReportDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports